const translations = {
  body: "Members won't be able to message you after you leave. You can always reopen the chat later.",
  heading: "Leaving the chat?",
  submit: "Leave chat"
};

export default translations;
